import { render } from "./AddPrix.vue?vue&type=template&id=2e9c5b0a"
import script from "./AddPrix.vue?vue&type=script&lang=js"
export * from "./AddPrix.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/services/AddPrix.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e9c5b0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e9c5b0a', __exports__)) {
    console.log('reload')
    api.reload('2e9c5b0a', __exports__)
  }
  
  module.hot.accept("./AddPrix.vue?vue&type=template&id=2e9c5b0a", () => {
    console.log('re-render')
    api.rerender('2e9c5b0a', render)
  })

}


export default __exports__